import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { HeaderComponent } from '@shared/layout/header/header.component';
import { SettingsService } from '@lib/setting/settings.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { Router } from '@angular/router';
import { CareTypeSingleResponse, StoreCareTypeSingleResponse, createCareTypeFormGroup } from '@lib/api/models/setting';
import { FormValidationService } from '@shared/services/form-validation.service';

@Component({
    selector: 'app-settings-care-types-add-page',
    imports: [HeaderComponent, ComponentsModule, FormsModule, ReactiveFormsModule],
    templateUrl: './settings-care-types-add-page.component.html',
    standalone: true,
    styleUrl: './settings-care-types-add-page.component.scss'
})
export class SettingsCareTypesAddPageComponent {

    private readonly _settingService = inject(SettingsService);
    private readonly _snackBar = inject(SnackBarService);
    private readonly _router = inject(Router);
    private readonly _formValidationService = inject(FormValidationService);

    protected readonly careTypeFormGroup = createCareTypeFormGroup();

    createCareTypeRequest = new SendableRequest<CareTypeSingleResponse, StoreCareTypeSingleResponse>({
        request: payload => this._settingService.createCareType(payload!),

        onSend: () => {
            this.careTypeFormGroup.disable();
        },

        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                icon: 'check',
                title: 'Care type added successfully.'
            });

            this._router.navigate(['/settings/care-types'])
                .then(success => {
                    if (!success) {
                        this._snackBar.open({
                            colour: 'error',
                            icon: 'error',
                            title: 'Failed to navigate to the care types.'
                        });
                        return;
                    }
                });
        },

        onError: () => {
            this.careTypeFormGroup.enable();
        }
    });

    addCareType(): void {
        if (this.createCareTypeRequest.loading()) {
            return;
        }

        if (!this.careTypeFormGroup.valid) {
            this._formValidationService.markFormGroupTouched(this.careTypeFormGroup);

            this._formValidationService.showFormErrors(this.careTypeFormGroup, true);

            return;
        }

        const careTypeData: StoreCareTypeSingleResponse = {
            name: this.careTypeFormGroup.value.name ?? '',
            description: this.careTypeFormGroup.value.description ?? ''
        };

        this.createCareTypeRequest.send(careTypeData);
    }

    cancel(): void {
        this._router.navigate(['/settings/care-types'])
            .then(success => {
                if (!success) {
                    this._snackBar.open({
                        colour: 'error',
                        icon: 'error',
                        title: 'Failed to navigate to the care types index page.'
                    });
                    return;
                }
            });

    }

}
